<template>
	<div class="card-base news-card-horizontal rouded-2 flex-row rounded-3 mb-3"
		 @click="openNewsDetail(news)"
		 :class="{'news-card-no-img': news.img_path.length === 0}"
	>
		<div class="row no-gutters">
			<div class="col-6">
				<seo-image :only="500" :data="news.img_path" :class="'news-card-horizontal-image'" :alt="news.title" :legacy-fallback="getLogoUrl" />
			</div>
			<div class="col-6 d-flex align-items-center">
				<div class="news-card-horizontal-body">
					<p class="news-card-horizontal-label" :class="{'d-none': tags.length === 0}">{{ tags }}</p>
					<h5 class="news-card-horizontal-title">{{ news.title }}</h5>
					<p class="news-card-horizontal-text">{{ news.introduction }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import {NewsCardInterface} from '../Interfaces/NewsCardInterface';
import NewsOpenerMixin from "../../Mixins/NewsOpenerMixin";
import SeoImage from "../SeoImage.vue";

export default defineComponent({
	name: 'NewsCardHorizontal',
	components: {SeoImage},
	mixins: [NewsOpenerMixin],
	props: {
		news: {
			type: Object as PropType<NewsCardInterface>,
			required: true
		}
	},
	computed: {
		tags(): string {
			return (this.news?.tags ?? []).join(', ')
		},
		getLogoUrl() {
			// @ts-ignore
			return document.querySelector(".layout-header__logo img").getAttribute('src');
		}
	}
});
</script>

<style lang="scss" scoped>

</style>
